import { fromJS } from 'immutable';

import { createReducer } from 'reducers/utils/helpers';

import { CLOSE_NOTIFY, OPEN_NOTIFY } from './types';

export * from './actions';

const initialState = fromJS({
  notify: {
    isOpen: false,
    options: undefined,
  },
});

export default createReducer(initialState, {
  [OPEN_NOTIFY]: (state, { options }) =>
    state.withMutations((mutableState) => mutableState.set('isOpen', true).set('options', options)),
  [CLOSE_NOTIFY]: (state) =>
    state.withMutations((mutableState) =>
      mutableState.set('isOpen', false).set('options', undefined),
    ),
});
